import React, { useState } from "react";
import { useLanguageContext } from "@/contexts/language-context";
import { Icon } from "@/components";

import "./styles.scss";

interface modalState {
  setModalState: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SelectLanguage: React.FC<modalState> = ({ setModalState }) => {
  const { values, updateLanguage } = useLanguageContext();
  const [searchItem, setSearchitem] = useState("");

  const filteredValues =
    values?.availableLanguages.filter((languages) => {
      return languages
        ?.toLocaleLowerCase()
        .includes(searchItem.toLocaleLowerCase());
    }) || [];

  const localelanguage = localStorage.getItem("selectedLanguage");

  return (
    <div className="selectBox">
      <div className="selecOverLay"></div>
      <div className="optionsBox">
        <div className="modal-head">
          <button
            onClick={() => {
              setModalState(false);
            }}
          >
            <Icon name="close" />
          </button>
        </div>

        {values?.availableLanguages.length > 0 ? (
          <>
            {values?.availableLanguages.length > 3 && (
              <div>
                <input
                  type="text"
                  placeholder="Search your prefered Language"
                  className="searchInput"
                  value={searchItem}
                  onChange={(e) => setSearchitem(e.target.value)}
                />
              </div>
            )}
            <div className="listBox">
              {filteredValues.length > 0 ? (
                <>
                  <h1>You want to learn</h1>
                  <div
                    className="listItem"
                    onClick={() => {
                      localStorage.removeItem("selectedLanguage");
                      setModalState(false);
                    }}
                  >
                    <div
                      className={
                        localelanguage === null ? "selected" : "checkBox"
                      }
                    ></div>
                    Select A language
                  </div>

                  {filteredValues?.map((item, index) => (
                    <div
                      className="listItem"
                      key={index}
                      onClick={() => {
                        localStorage.setItem("selectedLanguage", item);
                        setModalState(false);
                        updateLanguage(item);
                      }}
                    >
                      <div
                        className={
                          item.toLocaleLowerCase() ===
                          localelanguage?.toLocaleLowerCase()
                            ? "selected"
                            : "checkBox"
                        }
                      ></div>
                      <p>{item}</p>
                    </div>
                  ))}
                </>
              ) : (
                <div className="awSnap">
                  <Icon name="lens" />
                  <p>Language not found</p>
                </div>
              )}
            </div>
          </>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
};
